// extracted by mini-css-extract-plugin
module.exports = {"overall-section":"styles_overall-section__2dLcK"};